export default {
  STEP1: 'review',
  STEP2: 'choose',
  STEP3: 'finalize',
  STEP4: 'settings',
}
